/* eslint-disable @nx/enforce-module-boundaries */
import {
  Card,
  Stack,
  HStack,
  Text,
  Spinner,
  VStack,
  Image,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardPostBox } from 'v4/snippets/dashboard/feed/post-box';
import { SearchContext } from '../../context';
import { SearchCardSkeleton } from '../../search-card-skeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const SearchArticlesListing = forwardRef(
  ({ count = 0, listing,isMainList=false,fromPublic=false,fromIndex=false,fromSeperateList=false, ...props }, ref) => {
    const {
      articlesSearchListing,
      refetchArticlesSearch,
      articlesSearchIsFetching,
      search,
      activeTab,
      articlesFetchNextPage,
      articlesHasNextPage,
      articlesTotalCount,
      articlesSearchIsLoading,
    } = useContext(SearchContext);

    const { loggedIn } = useSelector((s) => s.user);

    useEffect(() => {
      if (!listing && activeTab === 'articles' && !isMainList) {
        refetchArticlesSearch?.();
      }
    }, [search, activeTab, listing]);
    const list = listing ?? articlesSearchListing;
    const test = list.slice(0, 5);
    const { t } = useTranslator();
    return (
      // <Box w="100%">
      <Stack w="100%" mt={0}>
        {articlesSearchIsFetching && articlesTotalCount===0 ? (
          <SearchCardSkeleton />
        ) : (
          <>
            {isMainList ? (
              <>
                {test?.map?.((li, liIndex) => (
                  <Card
                    key={liIndex}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    border="none"
                    borderColor="brandGray.200"
                    flex={1}
                    p={[2, 0]}
                    boxShadow="none"
                  >
                    <DashboardPostBox fromIndex={fromIndex} fromPublicEvent={fromPublic} post={li} />
                  </Card>
                ))}
              </>
            ) : (
              <>
                {articlesTotalCount > 0 ? (
                  <InfiniteScroll
                    dataLength={list?.length}
                    next={articlesFetchNextPage}
                    hasMore={articlesHasNextPage}
                    loader={
                      <HStack p={4} justifyContent="center" w="100%">
                        <Spinner />
                      </HStack>
                    }
                    // endMessage={
                    //   <Text style={{ textAlign: 'center' }}>
                    //     Yay! You have seen it all
                    //   </Text>
                    // }
                  >
                    {list?.map?.((li, liIndex) => (
                      <Card
                        key={liIndex}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        // border=" 1px solid #E4E6EB"
                        // borderColor="brandGray.200"
                        
                        flex={1}
                        p={0}
                        mb={3}
                        boxShadow="none"
                      >
                        <DashboardPostBox fromIndex fromSeperateList={fromSeperateList} fromArticle={true} post={li} />
                      </Card>
                    ))}
                  </InfiniteScroll>
                ) : (
                  <VStack
                justifyContent="center"
                alignItems="center"
                h="calc(80vh - 64px)"
              >
                <Image
                    src="/images/defaultSearchImage.svg"
                    alt="default Image"
                    width={["80%", "400px"]}
                  />
                <Text fontSize="18px" color="#AFAFAF" fontWeight="500">{t('searchPage.noResultsFound') || "No results found"}</Text>
                <Text fontSize="14px" color="#AFAFAF" fontWeight="500">{t('searchPage.tryRephrasing') || "Try shortening or rephrasing your search."}</Text>
              </VStack>
                )}
              </>
            )}
          </>
        )}
      </Stack>
      // </Box>
    );
  }
);
